import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { ALL_BRAND_TABLE_NAME, BRANDS_HEADERS, BRAND_AUTO_SELECTION, BRAND_LABEL, BRAND_SEARCH_PLACEHOLDER, BRAND_TABLE_NAME, BRAND_TABLE_SUBTITLE } from '../constants/merchantsConstants';
import { useDispatch, useSelector } from 'react-redux';
import { brandListSaga } from '../redux/saga/merchantServiceSelectors';
import { handleSortingInTable } from '../shared/utils/format.helpers';
import { merchantGetStoreListFromBrand, updateLoadingStatus } from '../redux/actions/merchantAction';
import { useNavigate } from 'react-router-dom';
import DataTable from '../shared/tables/DataTable';
import CustomPagination from '../shared/pagination/CustomPagination';

export default function OtterBrands() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const brandListData = useSelector(brandListSaga);
	const [brandList, setBrandList] = useState([]);
	const [wholeBrandList, setWholeBrandList] = useState([]);
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalPages, setTotalPages] = useState(0);
	const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'Ascending' });
	const [searchTerm, setSearchTerm] = useState('');

	const sortData = (data, { key, direction }) => {
		const dataToSort = [...data];
		return dataToSort.sort((a, b) => {
		if (a[key] < b[key]) return direction === 'Ascending' ? -1 : 1;
		if (a[key] > b[key]) return direction === 'Ascending' ? 1 : -1;
		return 0;
		});
	};

	useEffect(() => {
		setCurrentPage(0);
	}, [searchTerm]);

	// Filter data based on search term
	const filteredData = wholeBrandList.filter((brand) =>
		brand.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
		brand.id.toString().toLowerCase().includes(searchTerm.toLowerCase())
	);

	const sortedAndFilteredData = sortData(filteredData, sortConfig);
	const indexOfLastRow = (currentPage + 1) * rowsPerPage > wholeBrandList.length ? wholeBrandList.length : (currentPage + 1) * rowsPerPage;
	const indexOfFirstRow = indexOfLastRow - rowsPerPage > 0 ? indexOfLastRow - rowsPerPage : 0;
	const updatedRows = sortedAndFilteredData.slice(indexOfFirstRow, indexOfLastRow);

	useEffect(() => {
		// console.log('BRANDS ',brandListData, brandListData?.items.length)
		if (brandListData && brandListData?.items) {
		let selectedBrand = JSON.parse(sessionStorage.getItem('selectedBrand'));
		if (selectedBrand) {
			dispatch(updateLoadingStatus({ statustext: BRAND_AUTO_SELECTION, status: true }));
			brandListData.items.map((bd) => {
			if (bd['id'] === selectedBrand['id']) {
				setTimeout(() => {
				dispatch(merchantGetStoreListFromBrand(selectedBrand));
				}, 500);
			}
			});
		} else {
			setBrandList(brandListData?.items);
			setWholeBrandList(
			brandListData.items.map((bd) => ({
				...bd,
				stores: 0,
				'status-with-inidcation': true,
				connected: true,
			}))
			);
		}

		}
	}, [brandListData]);

	const onPageChange = (newPage) => {
		setCurrentPage(newPage);
	};

	const onRowsPerPageChange = (newRowsPerPage) => {
		setRowsPerPage(newRowsPerPage);
		setCurrentPage(0);
	};

	useEffect(() => {
		const newTotalPages = Math.ceil(filteredData.length / rowsPerPage);
		setTotalPages(newTotalPages);
	}, [filteredData.length, rowsPerPage]);

	const handleStorePageSort = (columnKey) => {
		handleSortingInTable(columnKey, sortConfig, setSortConfig);
	};

	const handleStoresClick = (rowData, columnKey) => {
		// console.log('clicked', rowData, columnKey);
		dispatch(merchantGetStoreListFromBrand(rowData));
	};

	return (
		<>
			<div className='store-container' data-testid='brand-id'>
				<Paper className='store-container--page-header'>
				<h4 className='store-container--title' data-testid='stores-title'>
					{BRAND_TABLE_NAME}
				</h4>
				</Paper>
			</div>

			<div className='store-page'>
				<div style={{ border: '1px solid #F1F1F1', backgroundColor: 'white', borderRadius: '4px' }}>
				<DataTable
					showAvatarOnStart={false}
					columns={BRANDS_HEADERS}
					data={updatedRows}
					tableName={ALL_BRAND_TABLE_NAME}
					tableSubTitle={BRAND_TABLE_SUBTITLE}
					searchplaceholder={BRAND_SEARCH_PLACEHOLDER}
					includeCheckbox={false}
					showAddToList={false}
					sortConfig={sortConfig}
					onSort={handleStorePageSort}
					clickableColumnKey='name'
					hideSearchIfOneStoreSelected={true}
					onCellClick={handleStoresClick}
					excludeColumnKey={['name', 'id']}
					onSearch={(searchTerm) => {
					setSearchTerm(searchTerm);
					setCurrentPage(0);
					}}
				/>

				<CustomPagination
					totalNumberOfPages={totalPages}
					currentPageNumber={currentPage}
					rowsPerPage={rowsPerPage}
					onPageChange={(event, newPage) => onPageChange(newPage)}
					onRowsPerPageChange={(event) => onRowsPerPageChange(parseInt(event.target.value, 10))}
					rowsPerPageOptions={[10, 20, 50]}
				/>
				</div>
			</div>
		</>
	);
}
